import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormGetService } from '../../services';

export const fetchFormGet = createAsyncThunk(
    'formGet/fetchFormGet',
    async ({ id }) => {
        const response = await FormGetService(id)
        return response.result
    }
);

const formGetSlice = createSlice({
    name: 'formGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formGetSlice.reducer;
